export const apiDelivery = '/api/v1/delivery';
